import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface PanelProps {
  titulo: ReactNode
  accion?: ReactNode
  pie?: ReactNode
  className?: string
  children: ReactNode
}

/** Tarjeta de columna de P03: encabezado con título y acción, cuerpo, pie. */
export function Panel({ titulo, accion, pie, className, children }: PanelProps) {
  return (
    <section
      className={cn(
        'flex min-h-0 min-w-0 flex-col rounded-tarjeta bg-tarjeta shadow-tarjeta',
        className,
      )}
      aria-label={typeof titulo === 'string' ? titulo : undefined}
    >
      {/*
        El título lleva el nombre del cliente y no se corta: en una columna
        angosta pasa a dos líneas antes que quedar en "Proyectos de Ca…". La
        acción no se encoge: es un botón, y un botón aplastado no se lee.
      */}
      <header className="flex min-h-14 min-w-0 items-start justify-between gap-3 px-4 pt-3 pb-1">
        <h2 className="mt-1 min-w-0 text-base font-semibold text-balance">{titulo}</h2>
        <div className="shrink-0">{accion}</div>
      </header>
      <div className="min-h-0 flex-1">{children}</div>
      {pie && <footer className="border-t border-borde px-4 py-2">{pie}</footer>}
    </section>
  )
}

/** Estado vacío del §8.6, con ícono, frase y acción. */
export function VacioPanel({
  icono,
  texto,
  children,
}: {
  icono: ReactNode
  texto: string
  children?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center gap-4 px-6 py-12 text-center">
      <span className="text-tinta-suave">{icono}</span>
      <p className="max-w-56 text-sm text-tinta-suave">{texto}</p>
      {children}
    </div>
  )
}
